import { Link, Tabs } from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import { BiTask } from 'react-icons/bi';
import { FaJediOrder, FaUsers } from 'react-icons/fa';
import { GoGoal } from 'react-icons/go';
import { MdEditSquare, MdSpaceDashboard } from 'react-icons/md';

import { Route } from '@/routes/_layout/$slug/dashboard';

import { DashboardActionsView } from './DashboardActionsView';
import { DashboardCollecteView } from './DashboardCollecteView';
import { DashboardIndicatorsView } from './DashboardIndicatorsView';
import { DashboardMainView } from './DashboardMainView';
import { DashboardMembersView } from './DashboardMembersView';
import { DashboardReferentialsView } from './DashboardReferentialsView';

const scrollProps = {
  scrollBehavior: 'smooth',
  overflow: 'auto',
  height: 'calc(100vh - 72px)',
};

export const DashboardTabs = () => {
  const navigate = useNavigate({ from: Route.fullPath });
  const { tab } = Route.useSearch();

  return (
    <Tabs.Root
      lazyMount
      unmountOnExit
      defaultValue="main"
      variant={'line'}
      value={tab}
      onValueChange={(e) =>
        navigate({
          search: () => ({
            tab: e.value,
          }),
        })
      }
    >
      <Tabs.List bg={'white'} h="72px">
        <Tabs.Trigger value="main" asChild>
          <Link unstyled h="full" ml="4">
            <MdSpaceDashboard />
            Main View
          </Link>
        </Tabs.Trigger>
        <Tabs.Trigger value="members" asChild>
          <Link unstyled h="full" ml="4">
            <FaUsers />
            Members View
          </Link>
        </Tabs.Trigger>
        <Tabs.Trigger value="actions" asChild>
          <Link unstyled h="full">
            <BiTask />
            Actions View
          </Link>
        </Tabs.Trigger>
        <Tabs.Trigger value="indicators" asChild>
          <Link unstyled h="full">
            <GoGoal />
            Indicators View
          </Link>
        </Tabs.Trigger>
        <Tabs.Trigger value="collecte" asChild disabled>
          <Link unstyled h="full">
            <MdEditSquare />
            Collecte View
          </Link>
        </Tabs.Trigger>
        <Tabs.Trigger value="referentials" asChild disabled>
          <Link unstyled h="full">
            <FaJediOrder />
            Referentials View
          </Link>
        </Tabs.Trigger>
      </Tabs.List>
      <Tabs.Content value="main" {...scrollProps}>
        <DashboardMainView />
      </Tabs.Content>
      <Tabs.Content value="members" {...scrollProps}>
        <DashboardMembersView />
      </Tabs.Content>
      <Tabs.Content value="actions" {...scrollProps}>
        <DashboardActionsView />
      </Tabs.Content>
      <Tabs.Content value="indicators" {...scrollProps}>
        <DashboardIndicatorsView />
      </Tabs.Content>
      <Tabs.Content value="collecte" {...scrollProps}>
        <DashboardCollecteView />
      </Tabs.Content>
      <Tabs.Content value="referentials" {...scrollProps}>
        <DashboardReferentialsView />
      </Tabs.Content>
    </Tabs.Root>
  );
};

export default DashboardTabs;
